module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    attrs: {
      "name": _vm.boxName
    }
  }, [_c('circle', {
    staticClass: "sign",
    attrs: {
      "name": _vm.signName
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "scale",
    attrs: {
      "name": _vm.scaleName
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "link",
    attrs: {
      "name": _vm.linkName
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "link",
    attrs: {
      "name": _vm.linkName
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "link",
    attrs: {
      "name": _vm.linkName
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "link",
    attrs: {
      "name": _vm.linkName
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0937d80e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toolbox.vue
// module id = 40
// module chunks = 0